import { type RefObject, useRef, useState } from 'react';
import { ACTION_ERROR, ACTION_VALIDATION_ERROR } from '../../../stores/state';
import { observer } from 'mobx-react';
import UploadFileForm from '../Attachments/UploadFileForm';
import AddAttachmentMessages from '../Attachments/AddAttachmentMessages';
import translations from './.vocab';
import { useTranslations } from '@vocab/react';
import { Box, Button } from 'braid-design-system';

interface Props {
  addAction: (file: File) => Promise<string>;
  onAddClick: () => void;
}

const AddAttachmentItem = ({ addAction, onAddClick }: Props) => {
  const { t } = useTranslations(translations);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(
    undefined,
  );
  const [loading, setLoading] = useState(false);
  const ref: RefObject<HTMLInputElement> = useRef<HTMLInputElement>(null);

  const onAdd = (file: File) => {
    setLoading(true);
    addAction(file).then((state: string) => {
      if (state === ACTION_ERROR) {
        setErrorMessage(
          t('Sorry, we couldn’t save your file. Can we try again?'),
        );
      } else if (state === ACTION_VALIDATION_ERROR) {
        setErrorMessage(t('Max 20 attachments...'));
      }
      setLoading(false);
    });
  };

  const onValidate = (isValid: boolean): void => {
    if (!isValid) {
      setErrorMessage(t('Max 20 attachments...'));
    } else {
      setErrorMessage(undefined);
    }
  };

  const onAddClickFunction = () => {
    onAddClick();
    if (ref.current !== null) {
      ref.current.click();
    }
    setErrorMessage(undefined);
  };
  const props = { errorMessage, loading };

  return (
    <>
      <Box display="inlineBlock">
        <Button onClick={onAddClickFunction} variant="transparent" bleed>
          {t('Add attachment')}
        </Button>
      </Box>
      <UploadFileForm ref={ref} onValidate={onValidate} onSubmit={onAdd} />
      <AddAttachmentMessages {...props} />
    </>
  );
};

export default observer(AddAttachmentItem);
